//COMMON
import 'intersection-observer';
import './common';

//SASS - COMMON
import '../sass/main.scss';

import Swiper from 'swiper';
import {
    Autoplay
} from 'swiper/modules';

const headerMain = document.getElementById('headerMain');

window.onscroll = function () {
    scrollHeaderHolder()
};

function scrollHeaderHolder() {
    if (window.pageYOffset > 0) {
        headerMain.classList.add("sticky");
    } else {
        headerMain.classList.remove("sticky");
    }
    if (window.pageYOffset > 165) {
        headerMain.classList.add("sticky-mobile");
    } else {
        headerMain.classList.remove("sticky-mobile");
    }
}

/**
 * 
 * Wyszukiwarka
 * 
 */

const searchWrapper = document.querySelector('[data-search]');
const searchOpen = searchWrapper.querySelector('.search-open');
const searchClose = searchWrapper.querySelector('.search-close');

searchOpen.addEventListener('click', e => {
    e.preventDefault();
    searchWrapper.classList.add('active');
})

searchClose.addEventListener('click', e => {
    e.preventDefault();
    searchWrapper.classList.remove('active');
})

const html = document.querySelector('html');
const mobileBtn = document.querySelector('.header-main__mobila-btn');
const mobileBtnClose = document.querySelector('.header-main__mobila-btn-close');

mobileBtn.addEventListener('click', e => {
    e.preventDefault();
    html.classList.add('mobile-menu');
})

mobileBtnClose.addEventListener('click', e => {
    e.preventDefault();
    html.classList.remove('mobile-menu');
})


/**
 * 
 * modal
 * 
 */

const modalBtn = document.querySelectorAll("[data-modal-btn]");
const modalWrapper = document.querySelectorAll("[data-modal]");

if(modalBtn) {
    modalBtn.forEach(el => {
        el.addEventListener('click', e => {
            e.preventDefault();
            console.log(el.dataset.modalBtn)
            document.querySelector(`[data-modal='${el.dataset.modalBtn}']`).style.display = "flex";
        
            document.querySelector(`[data-modal='${el.dataset.modalBtn}'] .close`).onclick = function() {
                document.querySelector(`[data-modal='${el.dataset.modalBtn}']`).style.display = "none";
            }
        
            window.onclick = function(event) {
                if (event.target == document.querySelector(`[data-modal='${el.dataset.modalBtn}']`)) {
                    document.querySelector(`[data-modal='${el.dataset.modalBtn}']`).style.display = "none";
                }
            }
        })
    })
}


